"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotelError(_ref) {
  var title = _ref.title,
      message = _ref.message;

  return _react2.default.createElement(
    "div",
    { className: "full-width-box hotel-error" },
    _react2.default.createElement(
      "div",
      { className: "fluid-error" },
      _react2.default.createElement(
        "p",
        null,
        _react2.default.createElement(
          "span",
          { className: "error-title" },
          title
        ),
        _react2.default.createElement(
          "span",
          { className: "error-detail" },
          message
        )
      )
    )
  );
} // HotelError

HotelError.propTypes = {
  title: _react.PropTypes.string,
  message: _react.PropTypes.string
};

exports.default = HotelError;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelError.js
// module id = 575
// module chunks = 0